import { Controller, useFormContext } from "react-hook-form";
import { Button, Input, Modal } from "components";
import { useToggle } from "utils";
import { TbInfoCircle } from "react-icons/tb";
import { FormReturnItemsType } from "../types";
import ReturnItemsDetail from "./Detail";

export function LinkToReturnItem(): JSX.Element {

    const { control, getValues } = useFormContext<FormReturnItemsType>()
    const return_id = getValues("return_id")

    return (
        <section className="flex items-end">
            <section className="grow">
                <Controller
                    control={control}
                    name="link"
                    render={({ field }) => (
                        <Input disabled label="LINK" defaultValue={field.value} />
                    )}
                />
            </section>
            <DetailSectionReturn
                return_id={return_id!}
            />
        </section>
    )
}

export function DetailSectionReturn(props: {
    return_id: number,
}) {
    const { isActive, toggle } = useToggle(false)

    return (
        <>
            <Button
                type="button"
                color="primary"
                onClick={toggle}
            >
                <TbInfoCircle />
            </Button>

            {isActive && (
                <Modal
                    isOpen
                    title="RETURN DETAIL"
                    closeModal={toggle}
                >
                    <Modal.Body>
                        <ReturnItemsDetail return_id={props.return_id.toString()!}/>
                    </Modal.Body>
                </Modal>
            )}
        </>
    )
}